import { concatStyleSets, memoizeFunction, mergeStyles } from "@fluentui/react";
import { Colors } from "@ms/uno-constants/lib/local/Colors";
export const goalRowHeight = "46px";
/**
 * Helper to get styles for GoalsRow
 * @param theme Theme of component
 * @param customStyles Any custom style overrides
 */ export const getStyles = memoizeFunction((theme, customStyles)=>{
    return concatStyleSets(getBaseGoalsRowStyles(theme), customStyles);
});
/**
 * Get base styles for GoalsRow
 * @param theme Theme of app
 */ const getBaseGoalsRowStyles = (theme)=>{
    const rootGoalsRowStack = {
        height: goalRowHeight,
        width: "100%"
    };
    const goalIconStack = {
        padding: "0px 5px",
        margin: "2px 4px 0px",
        overflow: "hidden"
    };
    const goalDateStack = {
        width: "120px",
        padding: "0px 5px",
        marginTop: "4px",
        "& input": {
            width: "120px !important"
        },
        "& .ms-TextField-fieldGroup": {
            backgroundColor: "transparent !important",
            borderColor: "transparent !important"
        }
    };
    const goalsGridRowStyles = {
        rootGoalsRowStack,
        goalIconStack,
        goalDateStack
    };
    return goalsGridRowStyles;
};
/**
 * Get the classnames associated with the computed styles
 * @param styles The styles for the component
 */ export const getClassNames = memoizeFunction((styles)=>({
        rootGoalsRowStack: mergeStyles("rootGoalsRowStack", styles.rootGoalsRowStack),
        goalIconStack: mergeStyles("goalIconStack", styles.goalIconStack),
        goalDateStack: mergeStyles("goalDateStack", styles.goalDateStack)
    }));
/**
 * Gets styles for the goal icon
 * @param props IIconStyleProps
 */ export const getGoalIconStyles = (theme)=>({
        root: {
            backgroundColor: Colors.PastelPink,
            color: Colors.NeutralPrimary,
            borderRadius: "50%",
            padding: "3px",
            display: "flex"
        }
    });
